import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '@app/api/axios';
import { showToaster } from '@shared/ui/messages/useToaster';
import i18n from '@app/i18n';

export const fetchDeclineRate = createAsyncThunk(
  'declineRate/fetchDeclineRate',
  async (_, { rejectWithValue }) => {
    try {
      const res = await instance.get('/decline-rate');
      return res.data;
    } catch (err) {
      showToaster(
        'error',
        err?.response?.data?.message || i18n.t('request_error'),
      );
      return rejectWithValue(err.message);
    }
  },
);

const declineRateSlice = createSlice({
  name: 'declineRate',
  initialState: {
    declineRateMonth: 0,
    declineRateMax: 0,
    statistics: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDeclineRate.fulfilled, (state, action) => {
      const item = action.payload?.data?.[0];

      state.declineRateMonth = item?.statistics?.['30d']?.avg ?? 0;
      state.declineRateMax = action.payload?.threshold ?? 0;
      state.statistics = item?.statistics ?? null;
    });
  },
});

export default declineRateSlice.reducer;
